import { render, staticRenderFns } from "./ConfigEndFlow.vue?vue&type=template&id=4edd2b38&"
import script from "./ConfigEndFlow.vue?vue&type=script&lang=js&"
export * from "./ConfigEndFlow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports